export const SET_IS_POST_LOADING = 'SET_IS_POST_LOADING';
export const FETCH_POSTS = 'FETCH_POSTS';
export const SELECT_POST = 'SELECT_POST';
export const SET_FILTER = 'SET_FILTER';
export const FETCH_POST = 'FETCH_POST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILED = 'SEARCH_FAILED';
export const GET_ALL_TAGS = 'GET_ALL_TAGS';
export const IMAGE_UPLOAD = 'IMAGE_UPLOAD';
